/**
 * Custom Display Component for displaying a text box as a link. The contents of the field will be treated as a URL
 */
import React from 'react';

import {FieldProp} from '../../types';
import {DisplayOnly} from './DisplayOnly';
import {Text} from './Text';

type LinkProps = FieldProp & {};

export const Link: React.FunctionComponent<LinkProps> = ({
                                                             field,
                                                             value,
                                                             displayOnly,
                                                             ...props
                                                         }): JSX.Element => {
    const linkDisplayText = field?.flowCustomDisplayComponentConfig?.linkDisplayText ?
        field.flowCustomDisplayComponentConfig.linkDisplayText
        :
        'Download';

    const linkTarget = field?.flowCustomDisplayComponentConfig?.linkTarget ?
        field.flowCustomDisplayComponentConfig.linkTarget
        :
        '_blank';

    const linkAdditionalCss = field?.flowCustomDisplayComponentConfig?.linkCss ?
        field.flowCustomDisplayComponentConfig.linkCss
        :
        '';

    const linkCss = [
        linkAdditionalCss,
    ]
        .filter(Boolean)
        .join(' ');

    return (
        <div>
            {displayOnly ?
                value &&
                <DisplayOnly>
                    <a href={value}
                       target={linkTarget}
                       className={linkCss}
                    >
                        {linkDisplayText === 'FIELD_VALUE' ? value : linkDisplayText}
                    </a>
                </DisplayOnly>
                :
                <Text {...props}
                      field={field}
                      value={value}
                      displayOnly={displayOnly}
                />
            }
        </div>
    );
};
